import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Cards.css";
import CardsFile from "./Cards.json";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from "aos"; // Import AOS
import Carousel from "react-bootstrap/Carousel";

const Cards = () => {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    setCards(CardsFile);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      <section className="text-center mt-5 mb-5" id="cards">
        <div className="container">
          <div className="head">
            <h2 className="m-5 fw-bold" style={{ color: "#FCDF5F" }}>
              الشقق المعروضة
            </h2>
          </div>
          <div className="row m-auto">
            {cards.map((card) => (
              <div
                className="col-lg-4 col-md-6 mb-2"
                data-aos="fade-up"
                key={card.id}
              >
                <div
                  className="card h-100"
                  style={{
                    width: "18rem",
                    backgroundColor: "#0D0D0D",
                    border: "2px solid #FCDF5F",
                  }}
                >
                  {card.vedUrl ? (
                    <div className="video-container">
                      <video
                        src={card.vedUrl}
                        controls
                        className="w-100"
                        style={{ height: "400px" }}
                      />
                    </div>
                  ) : (
                    <img
                      className="card-img-top"
                      style={{ height: "400px" }}
                      src={card.imageUrl}
                      alt="Card image cap"
                    />
                  )}
                  <div className="card-body">
                    <h5 className="card-text text-white mb-3">
                      {card.address}
                    </h5>
                    <div className="row pt-1 mt-2 border-top">
                      <div className="col-4" style={{ color: "#FCDF5F" }}>
                        نوع السكن
                      </div>
                      <div className="col-4" style={{ color: "#FCDF5F" }}>
                        الغرف
                      </div>
                      <div className="col-4" style={{ color: "#FCDF5F" }}>
                        السراير
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4 text-white">{card.type}</div>
                      <div className="col-4 text-white">{card.rooms}</div>
                      <div className="col-4 text-white">{card.beds}</div>
                    </div>
                    <NavLink
                      className="btn fw-bold text-dark mt-2"
                      style={{ backgroundColor: "#FCDF5F" }}
                      to={`/card/${card.id}`}
                    >
                      عرض التفاصيل
                    </NavLink>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cards;
